import { Component, OnInit } from '@angular/core';
import { NavigationService } from 'src/app/service/navigation.service';

@Component({
    selector: 'feedback',
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {
    constructor(private navigationService: NavigationService) { }

    ngOnInit(): void {
        this.navigationService.activity.setupQuickly('Обратная связь');
    }
}
